<article>
  <h1>《goingbus用户协议》</h1>
  <p>
    goingbus依据出租协议的规定为用户提供服务，出租协议在用户和goingbus之间具有合同上的法律效力。我们在此特别提醒您认真阅读、充分理解出租协议各条款，特别是其中所涉及的免除及限制goingbus责任的条款以及对用户权利限制条款。
  </p>

  <h2>第一章 goingbus提供的服务内容</h2>
  <p>
    第一条
    goingbus提供的服务是由goingbus基于APP或网站为技术平台所产生，具体服务内容：信息租借，例如：影视会员账号。
    <br />
    具体服务时间计算：一个月=30天、一个季度=90天、半年=180天、一年=360天。
  </p>

  <h2>第二章 用户需要满足哪些条件</h2>
  <p>
    第二条
    goingbus用户是指具有完全民事权利和民事行为能力，能够独立承担民事责任的自然人。在使用goingbus服务前，用户必须先在goingbus平台上进行注册。
  </p>
  <p>第三条 用户承诺以下事项：</p>
  <ul>
    <li>1、用户必须依照goingbus要求提供最新、真实、有效及完整的资料。</li>
    <li>
      2、用户有义务维护并更新资料，确保其最新、真实、有效及完整。若用户提供任何过时、错误、虚假或不完整的资料，goingbus将暂停或终止用户的账户，并拒绝用户使用goingbus服务的部份或全部的功能。针对这种情况，如果出现任何损失，goingbus不会承担任何责任，一律由用户承担。
    </li>
    <li>
      3、如果因为用户未及时更新相关资料，导致goingbus平台无法提供服务时发生错误所造成的损失，一律由用户承担，goingbus平台或者其他任何互联网平台不承担任何责任。
    </li>
  </ul>

  <h2>第三章 用户的守法义务及承诺</h2>
  <p>
    第四条
    用户必须承诺绝不为任何非法目的或方式使用goingbus服务，并且必须遵守相关法律、法规及一切使用互联网的国际惯例，遵守所有与goingbus服务有关的网络协议、规则和程序。
  </p>
  <p>
    第五条
    用户同意并保证不得利用goingbus服务从事侵害他人权益或违法的行为，若有违反者应负所有法律责任。上述行为包括：
  </p>
  <ul>
    <li>1、反对宪法所确定的基本原则，危害国家安全、泄漏国家秘密、颠覆国家政权、破坏国家统一的。</li>
    <li>2、侵害他人名誉、隐私权、商业秘密、商标权、著作权、专利权、其他知识产权及其他权益。</li>
    <li>3、违反依法律或合约所应负之保密义务。</li>
    <li>4、冒用他人名义使用goingbus服务。</li>
    <li>5、从事任何不法交易行为，如贩卖枪支、毒品、禁药、盗版软件或其他违禁物。</li>
    <li>6、提供赌博资讯或以任何方式引诱他人参与赌博。</li>
    <li>7、涉嫌洗钱、套现或进行传销活动的。</li>
    <li>8、从事任何可能含有电脑病毒或是可能侵害goingbus平台系統、资料等行为。</li>
    <li>9、利用goingbus平台进行可能对互联网或移动网正常运转造成不利影响之行为。</li>
    <li>10、仿冒goingbus系统设计、界面设计、业务模式运营同类型业务，有意使用户造成混淆，有冒用或抄袭行为。</li>
    <li>11、侵犯goingbus的商业利益，包括发布非经许可的商业广告。</li>
  </ul>

  <h2>第四章 隐私权保护及授权条款</h2>
  <p>
    第六条
    goingbus平台提供的是虚拟物品的租借，依靠互联网信息技术平台，为广大用户提供租借服务，其中租借的内容涉及到个人影视账号和密码，用户自愿把账号和密码提供给goingbus平台，goingbus平台有义务和责任对用户提供的信息进行保密不透露给其他任何人！
  </p>
  <p>
    第七条
    goingbus平台依据租号协议，把相关订单信息展示给该订单相关的用户，其中包括影视账号和密码！
  </p>
  <p>
    第八条
    由于账号租借的特殊性，出租的用户自愿承担使用goingbus平台进行出租的所带来的风险，包括账号密码被盗取、账号里的虚拟物品被破坏，影视账号被破坏等事项，出租用户愿意承担一切可能遭受到的损失，与goingbus平台或者微信公众平台等其它互联网平台无关！
  </p>

  <h2>第五章 知识产权的保护</h2>
  <p>
    第九条
    goingbus平台上所有内容，包括著作、图片、档案、资讯、资料、平台架构、平台画面的安排、网页设计，均由goingbus或其他权利人依法拥有其知识产权，包括商标权、专利权、著作权、商业秘密等。
  </p>
  <p>
    第十条
    非经goingbus平台或者相关用户的同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行侵犯他人权利的内容。
  </p>
  <p>
    第十一条
    尊重知识产权是用户应尽的义务，goingbus平台将尽力保护每个用户的知识产权或版权内容。
  </p>

  <h2>第六章 退款政策</h2>
  <p>
    第十二条
    您可以在首次租用后的24小时内联系goingbus申请首单退款。（注：代充值、礼品卡、兑换码类由于不记名、不挂失、不可回收，故售出即无法退款）
  </p>
  <p>
    第十三条
    您仅可以在正常租用期内该服务不可用例如(翻车，长期无有效订阅)的情况下申请退款，并且确保事先与goingbus取得协商以确定短期内无法解决该问题。在这种情况下，goingbus可以按比例向订户提供在服务不可用或不可用期间支付的服务费的按比例退款。
  </p>
  <p>
    第十四条
    退款通常会在7个工作日内处理，并按照购买时使用的原始付款方式退款。若要求退款，请向我们联系我们的客服进行退款。
  </p>

  <h2>第七章 免责声明</h2>
  <p>
    因以下情况造成网络服务在合理时间内的中断，goingbus无需为此承担任何责任；
  </p>
  <p>
    第十五条
    goingbus需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，goingbus保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。
  </p>
  <p>第十六条 因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；</p>
  <p>第十七条 用户的电脑软硬件和通信线路、供电线路出现故障的；</p>
  <p>
    第十八条
    因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因尽管有前款约定，goingbus将采取合理行动积极促使服务恢复正常。
  </p>
  <p>
    如果您在发现任何违反本服务协议以及其他任何单项服务的服务条款、goingbus各类公告之情形时，通知goingbus。您可以通过如下联络方式同goingbus联系：admin@goingbus.com
  </p>

  <h2>第八章 退款政策</h2>
  <p>
    第十九条
    首单退款：您可以在首次租用后的24小时内联系goingbus申请首单退款。（注：代充值、礼品卡、兑换码等因其不记名、不挂失、不可回收的特性，售出后即无法退款。）
  </p>
  <p>第二十条 服务不可用时退款：</p>
  <ul>
    <li>
      1.您仅可以在正常租用期内，因服务不可用（例如：系统故障、长期无有效订阅等）申请退款。退款比例根据服务中断的实际天数或小时数计算。
    </li>
    <li>2.在申请退款前，您必须与goingbus的客服取得联系。</li>
  </ul>
  <p>第二十一条 手续费：</p>
  <ul>
    <li>
      1.若您要求将退款退回至原始付款方式（包括在首单退款适用的无理由退款），我们将从退款金额中扣除10%的手续费。
    </li>
    <li>2.手续费适用于所有退款请求，包括因个人原因或非服务质量问题的退款。</li>
    <li>3.如果退款原因是由于goingbus自身责任（如服务故障、技术问题等）导致的，手续费将不被收取。</li>
  </ul>
  <p>第二十二条 钱包退款：</p>
  <ul>
    <li>
      1.若您选择将退款退至您的goingbus账户钱包，退款金额可按1:1比例抵扣本站内消费，并且不收取任何手续费。
    </li>
    <li>2.钱包余额仅可在本站内消费，不能提现、转让、赠送或出售。</li>
    <li>3.钱包内余额无法用于支付跨平台服务或任何其他不在goingbus服务范围内的费用。</li>
  </ul>
  <p>第二十三条 退款处理时效：</p>
  <ul>
    <li>1.退款请求将在7个工作日内处理，具体退款时间可能因支付方式及其他因素有所不同。</li>
    <li>2.若您的退款请求因特殊情况延迟处理，我们将及时与您沟通，并提供退款处理的最新进度。</li>
    <li>3.若有任何问题或异议，您可随时联系goingbus客服，我们将协助您解决问题。</li>
  </ul>
</article>
